import type { GridRowSelectionModel } from '@mui/x-data-grid-premium'
import type { AlertsListRow } from './alertsListFilters'

/**
 * The most alerts one "everything that matches" send reads from the Gateway.
 * The list route has no cap of its own, and the send route takes every
 * premise id in one body, so a bigger match is refused rather than guessed.
 */
export const MAX_SEND_ALERTS = 1000

/** The customers behind the ticked rows, each once, in list order. */
export const premiseIdsOfSelection = (
  rows: AlertsListRow[],
  selection: GridRowSelectionModel
): number[] => {
  const ticked = (row: AlertsListRow) =>
    selection.type === 'exclude'
      ? !selection.ids.has(row.id)
      : selection.ids.has(row.id)
  const premises = new Set<number>()
  for (const row of rows) {
    if (ticked(row) && row.premiseId != null) premises.add(row.premiseId)
  }
  return [...premises]
}

/**
 * "Every matching row" is ticked and the page holds only some of them, so the
 * rest must be read from the Gateway before the customers are known.
 */
export const needsMatchingRows = (
  selection: GridRowSelectionModel,
  pageRows: AlertsListRow[],
  total: number
): boolean => selection.type === 'exclude' && pageRows.length < total
